import { Suspense, lazy, useState } from "react";
import { useTranslation } from "react-i18next";
import { WeeklyScheduleView } from "@/components/athlete/schedule/WeeklyScheduleView";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { AthleteBrandHeader } from "@/components/athlete/AthleteBrandHeader";

// Lazy load the ReservationsView component to improve initial loading time
const ReservationsView = lazy(() =>
  import("@/components/athlete/schedule/ReservationsView").then(mod => ({
    default: mod.ReservationsView
  }))
);

// Create a loading fallback component
const LoadingFallback = () => (
  <Card className="w-full">
    <div className="p-6 space-y-4">
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-4 w-72" />
      <div className="pt-4 space-y-2">
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-32 w-full" />
      </div>
    </div>
  </Card>
);

const AthleteSchedule = () => {
  const { t } = useTranslation(["athlete", "schedule"]);
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  
  return (
    <div className="athlete-page-bg min-h-screen flex flex-col w-full">
      <main className="athlete-schedule-page flex-1 p-4 md:p-6 max-w-7xl mx-auto w-full">
        <AthleteBrandHeader
          title={t('tabs.schedule', { ns: 'athlete' })}
          subtitle={t('schedule.description', { ns: 'athlete' })}
          backgroundKey="schedule"
          showLogo={false}
        />

        <Suspense fallback={<LoadingFallback />}>
          <WeeklyScheduleView
            selectedDate={selectedDate}
            onDateSelect={setSelectedDate}
          />
        </Suspense>
      </main>
    </div>
  );
};

export default AthleteSchedule;
